require('../../proto/javascript/netop_rc_route_pb')

import { createRouteMeta } from './metaCreators'

export class RouteMessageCreator {
  constructor () {
    this._createRouteMeta = createRouteMeta
  }

  create = (agentAddress, bodyBinary) => {
    const routeMessage = new proto.netop.rc.route.RouteMessage()
    routeMessage.setNetopMessageType('netop.rc.route.RouteMessage')
    const meta = this._createRouteMeta()
    routeMessage.setMeta(meta)
    routeMessage.setTo(agentAddress)
    routeMessage.setBody(bodyBinary)
    const routeMessageBinary = routeMessage.serializeBinary()

    return routeMessageBinary
  }
}
